import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-upgrade-dialog',
    templateUrl: './upgrade-dialog.component.html',
    styleUrl: './upgrade-dialog.component.scss',
    standalone: false
})
export class UpgradeDialogComponent {
  constructor(private dialogRef: MatDialogRef<UpgradeDialogComponent>,private router: Router){}

  ngOnInit() {}

  goToBilling(){
    this.router.navigate(['/billing']);
    this.dialogRef.close('cancelDialog');
  }
}